'use strict';

const menu = {
	burgerEvents : function(){
		const burger = document.getElementById('toggleNav');
		if( burger ){
			burger.addEventListener('click', e => {
				e.currentTarget.classList.toggle('open');
				const headerNav = document.getElementsByClassName('headerNav');
				document.body.classList.toggle('menuMobileOpen');
				if( headerNav ){
					headerNav[0].classList.toggle('open');
				}
			})
		}
	},
	init : function(){
		this.burgerEvents();
	}
};


window.addEventListener('DOMContentLoaded', function() {
	menu.init();
});